import { getI18n } from "../../../i18n/i18n";
import { once } from "../../../util/once";
import { messages as messagesDe } from "../locales/de/messages";
import { messages as messagesEn } from "../locales/en/messages";
import { messages as messagesEs } from "../locales/es/messages";
import { messages as messagesFr } from "../locales/fr/messages";
import { messages as messagesIt } from "../locales/it/messages";
import { messages as messagesJa } from "../locales/ja/messages";
import { messages as messagesPt } from "../locales/pt/messages";
import { messages as messagesRu } from "../locales/ru/messages";
export var selectV2Catalog = {
  de: messagesDe,
  en: messagesEn,
  es: messagesEs,
  fr: messagesFr,
  it: messagesIt,
  ja: messagesJa,
  pt: messagesPt,
  ru: messagesRu
};
export var injectCatalog = once(function () {
  getI18n().load(selectV2Catalog);
});
//# sourceMappingURL=SelectCatalog.js.map